module.exports = __webpack_public_path__ + "static/media/health-card.07dfac99.svg";